import { AxiosInstance } from 'axios';

import { EnterpriseAPIApiFactory } from '@cast/openapi-organization-management';

import { AXIOS_CONFIGURATION } from '../constants';

export const EnterprisesApiAdapter = (client: AxiosInstance) => {
  const enterprisesGeneratedApi = EnterpriseAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    listUserGroups: enterprisesGeneratedApi.enterpriseAPIListGroups,
    batchCreateUserGroups:
      enterprisesGeneratedApi.enterpriseAPIBatchCreateEnterpriseGroups,
    batchUpdateUserGroups:
      enterprisesGeneratedApi.enterpriseAPIBatchUpdateEnterpriseGroups,
    batchDeleteUserGroups:
      enterprisesGeneratedApi.enterpriseAPIBatchDeleteEnterpriseGroups,
    inviteUsers: enterprisesGeneratedApi.enterpriseAPIInviteUsers,
    listMembers: enterprisesGeneratedApi.enterpriseAPIListMembers,
    listChildrenOrganizations:
      enterprisesGeneratedApi.enterpriseAPIListChildrenOrganizations,
    createChildOrganization:
      enterprisesGeneratedApi.enterpriseAPICreateChildOrganization,
    deleteChildOrganization:
      enterprisesGeneratedApi.enterpriseAPIDeleteChildOrganization,
    addUserToChildOrganization:
      enterprisesGeneratedApi.enterpriseAPIAddUserToChildOrganization,
    overrideRoleBindings:
      enterprisesGeneratedApi.enterpriseAPIOverrideUserRoleBindings,
    listRoleBindings: enterprisesGeneratedApi.enterpriseAPIListRoleBindings,
    batchCreateRoleBindings:
      enterprisesGeneratedApi.enterpriseAPIBatchCreateEnterpriseRoleBindings,
    batchDeleteRoleBindings:
      enterprisesGeneratedApi.enterpriseAPIBatchDeleteEnterpriseRoleBindings,
    listServiceAccounts:
      enterprisesGeneratedApi.enterpriseAPIListEnterpriseServiceAccounts,
    batchCreateServiceAccounts:
      enterprisesGeneratedApi.enterpriseAPIBatchCreateEnterpriseServiceAccounts,
    batchUpdateServiceAccounts:
      enterprisesGeneratedApi.enterpriseAPIBatchUpdateEnterpriseServiceAccounts,
    batchDeleteServiceAccounts:
      enterprisesGeneratedApi.enterpriseAPIBatchDeleteEnterpriseServiceAccounts,
  };
};
